import { __assign } from "tslib";
import classNames from 'classnames';
import React, { useImperativeHandle, useRef, useState } from 'react';
import styles from './textfield.module.css';
import { capitalize } from '../../../library';
function typeByVisibility(inputType, isVisible) {
    if (inputType === 'password')
        return isVisible ? 'text' : 'password';
    return inputType;
}
function getInputModeByType(inputType) {
    if (inputType === 'number')
        return 'numeric';
    if (inputType === 'email')
        return 'email';
    if (inputType === 'url')
        return 'url';
    return 'text';
}
function checkAllowedMetaKeys(key) {
    return key !== 'Backspace' && key !== 'Tab' && key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Delete';
}
function restrictInputCharacters(event, fieldType) {
    if (fieldType === 'number' && /\D/gi.test(event.key) && checkAllowedMetaKeys(event.key))
        event.preventDefault();
}
/**
 * @deprecated Replaced by 'TextField'
 */
export var Textfield = React.forwardRef(function (props, outerRef) {
    var _a, _b, _c;
    var _d;
    var _e = useState(false), contentVisible = _e[0], setContentVisible = _e[1];
    var _f = props.type, type = _f === void 0 ? 'text' : _f, _g = props.disabled, disabled = _g === void 0 ? false : _g, _h = props.haserror, hasError = _h === void 0 ? false : _h, _j = props.variant, variant = _j === void 0 ? 'standard' : _j, _k = props.responsive, responsive = _k === void 0 ? false : _k, _l = props.readOnly, readOnly = _l === void 0 ? false : _l;
    if (type === 'password' && variant === 'large' && process.env.NODE_ENV !== 'production') {
        throw new Error('<Textfield>: Cannot have type="password" on variant="large"');
    }
    var innerRef = useRef(null);
    useImperativeHandle(outerRef, function () { return innerRef.current; }, []);
    var cleanInputType = typeByVisibility(type, contentVisible);
    var cleansedProps = __assign(__assign({}, props), { className: void 0, label: void 0, id: (_d = props.id) !== null && _d !== void 0 ? _d : props.name, placeholder: props.label, type: cleanInputType, variant: void 0, haserror: void 0 });
    return (React.createElement("div", { className: classNames('inputWrapperDeprecated', styles.textfieldWrapper, props.className, (_a = {},
            _a[styles.hasAction] = type === 'password',
            _a.hasError = hasError,
            _a[styles.readOnly] = readOnly,
            _a[styles.disabled] = disabled,
            _a.responsive = responsive,
            _a), styles["textfieldVariant".concat(capitalize(variant))], "kplr_textfieldWrapper") },
        React.createElement("input", __assign({ inputMode: getInputModeByType(cleanInputType), onKeyDown: function (event) { return restrictInputCharacters(event, type); } }, cleansedProps, { className: classNames(styles.textfieldInput, (_b = {}, _b[styles.noLabel] = !props.label, _b[styles.hasFocusStyles] = variant === 'standard', _b)), ref: outerRef })),
        !!props.label && (React.createElement("label", { className: classNames(styles.textfieldLabel, (_c = {}, _c[styles.disabled] = disabled, _c)), htmlFor: props.name }, props.label)),
        type === 'password' && !disabled && (React.createElement("div", { className: classNames(styles.textfieldAction), tabIndex: -1, onClick: function (event) {
                event.preventDefault();
                event.stopPropagation();
                setContentVisible(!contentVisible);
            } },
            React.createElement("svg", { tabIndex: -1, fill: "none", viewBox: "0 0 17 13" },
                React.createElement("path", { fill: "var(--accent-2_1)", d: "M8.12997 2.42854c2.80113 0 5.29923 1.5214 6.51873 3.92848-1.2195 2.40709-3.7176 3.92848-6.51873 3.92848-2.80114 0-5.29926-1.52139-6.51876-3.92848 1.2195-2.40708 3.71762-3.92848 6.51876-3.92848Zm0-1.42854C4.43453 1 1.27862 3.22138 0 6.35702 1.27862 9.49267 4.43453 11.714 8.12997 11.714c3.69543 0 6.85133-2.22133 8.12993-5.35698C14.9813 3.22138 11.8254 1 8.12997 1Zm0 3.57135c1.01994 0 1.84772.79998 1.84772 1.78567 0 .9857-.82778 1.78568-1.84772 1.78568s-1.84772-.79998-1.84772-1.78568c0-.98569.82778-1.78567 1.84772-1.78567Zm0-1.42854c-1.83294 0-3.3259 1.44283-3.3259 3.21421 0 1.77139 1.49296 3.21422 3.3259 3.21422 1.83294 0 3.32593-1.44283 3.32593-3.21422 0-1.77138-1.49299-3.21421-3.32593-3.21421Z" }),
                contentVisible ? (React.createElement("g", { id: "hide" },
                    React.createElement("path", { fill: "var(--accent-2_1)", d: "m3.69934.285156 10.557811 10.557811-.707106.707107L2.992233.992263z" }),
                    React.createElement("path", { fill: "var(--background)", d: "m2.99219.992188 10.557811 10.557811-.707106.707107L2.285083 1.699295z" }))) : (React.createElement(React.Fragment, null))),
            React.createElement("span", null, contentVisible ? 'Hide' : 'Show')))));
});
Textfield.displayName = 'Textfield';
export default Textfield;
